import "./App.css";
import Box from "@mui/joy/Box";
import React from "react";
import logo from "./logo.svg";
import { Route, Routes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Button from "@mui/material/Button";
import Posts from "./routes/Posts";
import Projects from "./routes/Projects/Projects";
import Settings from "./routes/Settings";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Slide from "@mui/material/Slide";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

import { Link as RouterLink } from "react-router-dom";

import Notes from "./routes/Notes";
// import Explorer from "./routes/Explorer";

import Banner from "./Banner";
import PrimaryAppBar from "./navigation/AppBar";
import Footer from "./Footer";
import SingularPost from "routes/SingularPost";
import About from "routes/About";
import Support from "routes/Support";
import ProjectLens from "routes/Projects/ProjectLens";
import ProjectEditor from "routes/Projects/ProjectEditor/ProjectEditor";
import FAQ from "routes/FAQ";
import ImageUploader from "routes/Projects/ProjectEditor/ImageUploader";
import { Tag } from "constructs/Tag";
import TagUploader from "routes/Projects/ProjectEditor/TagUploader";

import { routes } from "navigation/routes";
import { useGetImagesQuery } from "services/image/imageApi";

function App() {
  const [scrollTarget, setScrollTarget] = React.useState<
    Node | Window | undefined
  >(undefined);
  
  const { isFetching, isLoading, data: bannerOptions } = useGetImagesQuery({ kinds: "banner" });
  
  // NOTE: If this is set to an empty array, it will constantly cause the banner to update when resizing breakpoints are hit
  //       or if any of the hooks on this page run
  const filter: Tag[] | undefined = undefined;


  
  const theme = useTheme();
  const midToLarge = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const smallToMid = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const lessThanSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const allowDrawer = smallToMid || lessThanSmall;

  const [drawerOpen, toggleDrawer] = React.useState(false);

  const handleToggleDrawer = (event: React.BaseSyntheticEvent) => {
    toggleDrawer((state) => !state);
  };

  // const trigger = useScrollTrigger({ target: window });
  // const filter = ["ero"];

  return (
    <CssBaseline>
      <div
        className="App"
        ref={(node) => {
          if (node) {
            setScrollTarget(node);
          }
        }}
      >
        <NavDrawer
          open={drawerOpen}
          shouldRender={allowDrawer}
          toggleDrawer={toggleDrawer}
        />
        <Box
          sx={{ minHeight: "100vh" }}
          bgcolor="primary"
          // sx={{ paddingTop: "64px" }}
        >
          <Banner
            // bannerTarget={ bannerTarget }
            filter={filter}
          />
          {/* <Slide appear={false} direction="down" in={!trigger}> */}
          <PrimaryAppBar toggleDrawer={handleToggleDrawer} />

          {/* </Slide> */}
          <Routes>
            <Route path="/" element={<Posts />} />
            <Route path="/posts" element={<Posts />} />
            <Route path="/wordpress" element={<Posts />} />
            <Route path="/posts/:postId" element={<SingularPost />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:projectId" element={<ProjectLens />} />
            <Route
              path="/project-editor/:passkey"
              element={<ProjectEditor />}
            />

            <Route path="/image-editor/:passkey" element={<ImageUploader />} />

            <Route path="/tag-editor/:passkey" element={<TagUploader />} />

            <Route path="/faq" element={<FAQ />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/about" element={<About />} />
            <Route path="/support" element={<Support />} />
          </Routes>
          <Footer />
        </Box>
      </div>
    </CssBaseline>
  );
}

export interface NavDrawerProps {
  shouldRender?: boolean | undefined;
  open: boolean;
  toggleDrawer: (arg: boolean) => void;
}

const NavDrawer = ({ shouldRender, open, toggleDrawer }: NavDrawerProps) => {
  const theme = useTheme();
  
  if (!shouldRender) {
    return null;
  }

  const handleCloseDrawer = (event: React.BaseSyntheticEvent) => {
    toggleDrawer(false);
  };

  const handleOpenDrawer = (event: React.BaseSyntheticEvent) => {
    toggleDrawer(true);
  };

  return (
    <SwipeableDrawer
      open={open}
      onClose={handleCloseDrawer}
      onOpen={handleOpenDrawer}
    >
      <List>
        {routes
          .filter((route) => route.active)
          .map((route) => (
            <ListItem key={route.name} sx={{ justifyContent: 'start' }}>
              <Button fullWidth sx={{ color: theme.palette.secondary.main, justifyContent: 'start' }}>
                <RouterLink
                  style={{ color: theme.palette.secondary.main, textDecoration: 'none'}} 
                  to={route.url}>
                    {route.name}
                  </RouterLink>
              </Button>
            </ListItem>
          ))}
      </List>
    </SwipeableDrawer>
  );
};

export default App;
